import { swymFetch } from '~/services/fetch-swym'

import type { ICommunity } from '~/entities/container/community/interfaces/community'

import { extractContents } from '~/features-shared/content/api/parser-exalead'

import type { ExaleadService } from '~/interfaces/crud-service'
import type { ExaleadResponse } from '~/interfaces/services-dto'

export const CommunityExploreExaleadService: ExaleadService<ICommunity> = {
  async getAll(params) {
    const response = await swymFetch.post('/api/exalead/searchdiscovercommunities', {
      json: {
        params: {
          with_synthesis: true, // mandatory to fetch tags
          legacyFormat: false,
          ...params,
        },
      },
    })
      .json<ExaleadResponse>()

    return {
      data: extractContents(response)
        .map(el => ({
          ...el,
          subject_uri: el.resourceid,
          description: el.community_description,
          owner: {
            first_name: el.user_firstname,
            last_name: el.user_lastname,
            login: el.username,
            user_state: el.ut_state,
          },
        })) as ICommunity[],
      total: response.nhits,
    }
  },
  async getRawData(params) {
    const response = await swymFetch.post('/api/exalead/searchdiscovercommunities', {
      json: {
        params: {
          legacyFormat: false,
          query: '#all',
          with_synthesis: true, // mandatory to fetch tags
          ...params,
          start: 0, // force to fetch nothing but tags
          nresults: 0, // force to fetch nothing but tags
        },
      },
    })
      .json<ExaleadResponse>()

    return {
      groups: response.groups,
      hits: response.hits,
      total: response.nhits,
    }
  },
  async count() {
    throw new Error('Function not implemented.')
  },
}
